export default __webpack_public_path__ + "static/media/775.4a37cc4b.gif";